import { render } from "./api-tokens.vue?vue&type=template&id=611e8ad6"
import script from "./api-tokens.vue?vue&type=script&lang=js"
export * from "./api-tokens.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\iuril\\Documents\\econopro\\mainapp\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__